import "../sass/main.scss";

import "slick-carousel/slick/slick";

import "./script-modal";
import "./_sprite";
import {gsap} from "gsap";

let pattern_row = '<svg viewBox="0 0 1920 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect y="23" width="100%" height="100%" fill="#D0E0E3"/> <path d="M1777.85 0L1755.33 22.9281H1920V0H1777.85Z" fill="#8CB9BE"/> </svg>';
let pattern_row_2 = '<svg  viewBox="0 0 1919 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="-1" y="23" width="100%" height="100%" fill="#8CB9BE"/> <path d="M1776.85 0L1754.33 22.9281H1919V0H1776.85Z" fill="#47929A"/> </svg>';

jQuery(document).ready(function () {
    jQuery('.slick').slick();

    addSpanToCheckbox();

    stickToSides();

    jQuery('.frm_checkbox > span, .frm_radio > span').click(function () {
        jQuery(this).prev('input').click();
    });

    jQuery('.sprite-icon-menu-burger').click(function () {
        jQuery(this).toggleClass('is-active');
        jQuery('html').toggleClass('is-active-menu-burger');
    });

    jQuery('.js-card').click(function () {
        window.location.href = jQuery(this).find('.js-card-href').attr('href');
    });

    jQuery('.pattern-before').each(function () {
        if (jQuery(this).hasClass('pattern-before-2')) {
            pattern_row = pattern_row_2;
        }
        let block = jQuery('<div class="block-pattern block-pattern-before">' + pattern_row + '</div>').prependTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-before-no-margin'))
            jQuery(this).css('margin-top', height);

        let prevRow;
        if (jQuery(this).hasClass('vc_row')) {
            prevRow = jQuery(this).prev();
            if (prevRow.hasClass('vc_clearfix')) {
                prevRow = prevRow.prev();
            }
        } else {
            prevRow = jQuery(this).prev();
            if (prevRow.hasClass('site-content')) {
                let vc_rows = prevRow.find('.vc_row');
                let count_vc_rows = vc_rows.length;
                prevRow = vc_rows.eq(count_vc_rows);
            }
        }

        if (prevRow.length) {
            let paddingBottomOfPrevRow = prevRow.css('padding-bottom');
            paddingBottomOfPrevRow = paddingBottomOfPrevRow.slice(0, -2);
            paddingBottomOfPrevRow = parseInt(paddingBottomOfPrevRow);
            paddingBottomOfPrevRow = paddingBottomOfPrevRow + height;
            prevRow.css('padding-bottom', paddingBottomOfPrevRow);
        }

        patternBgColor(jQuery(this), block);
    });

    jQuery('.pattern-after').each(function () {
        if (jQuery(this).hasClass('pattern-after-2')) {
            pattern_row = pattern_row_2;
        }
        let block = jQuery('<div class="block-pattern block-pattern-after">' + pattern_row + '</div>').appendTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-after-no-margin'))
            jQuery(this).css('margin-bottom', height);

        let nextRow;
        if (jQuery(this).hasClass('vc_row')) {
            nextRow = jQuery(this).next();
            if (nextRow.hasClass('vc_clearfix')) {
                nextRow = nextRow.next();
            }
        } else {
            nextRow = jQuery(this).next();
            if (nextRow.hasClass('site-content')) {
                nextRow = nextRow.find('.vc_row').eq(1);
            }
        }

        if (nextRow.length) {
            let paddingBottomOfNextRow = nextRow.css('padding-top');
            paddingBottomOfNextRow = paddingBottomOfNextRow.slice(0, -2);
            paddingBottomOfNextRow = parseInt(paddingBottomOfNextRow);
            paddingBottomOfNextRow = paddingBottomOfNextRow + height;
            nextRow.css('padding-top', paddingBottomOfNextRow);
        }

        patternBgColor(jQuery(this), block);
    });

    document.querySelectorAll(':not( .tabs ):scope a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            // e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    });
});

jQuery(window).resize(function () {
    stickToSides();
});

jQuery(window).scroll(function () {
    jQuery('.count:not(.active-counter)').each(function (i, elt) {
        let element = jQuery(elt);

        if (isScrolledIntoView(element)) {
            let counterTxt = jQuery(element).text();
            counterTxt = counterTxt.replace(',', '.');
            counterTxt = counterTxt.split(' ').join('');
            // console.log('counter : ' + counterTxt);
            jQuery(this).addClass('active-counter').prop('Counter', 0).animate({
                Counter: parseInt(counterTxt)
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    now = Math.ceil(now);
                    // now = now.toFixed(1);
                    jQuery(this).text(numberFormat(now));
                    // jQuery(this).text(now.toLocaleString());
                }
            });
        }
    });
});

jQuery(document).on('frmPageChanged', function (event, form, response) {
    addSpanToCheckbox();
});

function patternBgColor(parent, block) {
    if (jQuery(parent).hasClass('bg-color-primary')) {
        block.addClass('block-pattern-bg-color-primary');
    } else if (jQuery(parent).hasClass('bg-color-secondary')) {
        block.addClass('block-pattern-bg-color-secondary');
    } else if (jQuery(parent).hasClass('bg-color-tertiary')) {
        block.addClass('block-pattern-bg-color-tertiary');
    } else if (jQuery(parent).hasClass('bg-color-white')) {
        block.addClass('block-pattern-bg-color-white');
    } else if (jQuery(parent).hasClass('bg-color-black')) {
        block.addClass('block-pattern-bg-color-black');
    }
}

function addSpanToCheckbox() {
    jQuery('input[type=radio]:not(.is-loaded)').after('<span>').addClass('is-loaded');
    jQuery('input[type=checkbox]:not(.is-loaded)').after('<span class="is-loaded">').addClass('is-loaded');
}

function stickToSides() {
    let maxWidth = 2300;
    let $window = jQuery(window);

    jQuery('.stickToLeft').each(function () {
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var left = offset;

        if ($window.width() < maxWidth)
            jQuery(this).css('margin-left', -offset);
        else
            jQuery(this).css('margin-left', '');

        jQuery(this).width(width + left);
    });

    jQuery('.stickToRight').each(function () {
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var right = $window.width() - (offset + width)

        if ($window.width() < maxWidth)
            jQuery(this).css('margin-right', -right);
        else
            jQuery(this).css('margin-right', '');

        jQuery(this).width(width + right);
    });
}

function isScrolledIntoView(elem) {
    let $elem = jQuery(elem);
    let $window = jQuery(window);

    let docViewTop = $window.scrollTop();
    let docViewBottom = docViewTop + $window.height();

    let elemTop = $elem.offset().top;
    let elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function numberFormat(nStr) {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? ',' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ' ' + '$2');
    }
    return x1 + x2;
}
